import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const BreadcrumbContainer = styled.div`
  display: flex;
  margin-bottom: 25px;
  flex-wrap: wrap;
  word-break: break-all;
  @media screen and (max-width: 1100px) {
    margin-bottom: 10px;
    padding: 0px 15px;
  }
  & .breadcrumb-icon {
    margin: 0 4px;
  }
`

export const BreadcrumbItem = styled(Link)`
  @media screen and (min-width: 1100px) {
    font-size: 13px;
    color: ${props => props.theme.color.black4};
    font-family: ${props => props.theme.font.family.medium};
    text-decoration: none;
    svg {
      margin: 0px 10px;
    }
    &.active {
      color: ${props => props.theme.color.black2}
    }
  }
`
